import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { toast } from "sonner";
import { Building2 } from "lucide-react";

export default function WholesaleLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/login", { email: email.trim().toLowerCase(), password });
      const me = await api.get("/wholesale/me").catch(()=>null);
      if (!me?.data) { toast.error("This account is not a wholesale account"); setBusy(false); return; }
      nav("/wholesale");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#3B2F2F] to-[#2A2020] flex items-center justify-center p-4">
      <div className="bg-[#FDFBF7] rounded-2xl p-8 max-w-md w-full shadow-2xl">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-xl bg-[#D4AF37] text-[#3B2F2F] flex items-center justify-center"><Building2 className="w-6 h-6"/></div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">Wholesale portal</div>
            <div className="font-serif-display text-2xl text-[#3B2F2F]">Sign in</div>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <label className="block">
            <div className="text-[10px] uppercase tracking-widest text-stone-500 font-outfit font-semibold mb-1.5">Business email</div>
            <Input type="email" value={email} onChange={e=>setEmail(e.target.value)} data-testid="wh-login-email" required/>
          </label>
          <label className="block">
            <div className="text-[10px] uppercase tracking-widest text-stone-500 font-outfit font-semibold mb-1.5">Password</div>
            <Input type="password" value={password} onChange={e=>setPassword(e.target.value)} data-testid="wh-login-password" required/>
          </label>
          <button type="submit" disabled={busy} data-testid="wh-login-btn"
                  className="w-full bg-[#3B2F2F] text-white rounded-md py-2.5 font-medium hover:bg-black disabled:bg-stone-400">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <div className="text-xs text-stone-500 mt-6 text-center">
          Not a wholesale partner yet?{" "}
          <a href="/wholesale/enquiry" className="text-[#3B2F2F] font-semibold underline hover:text-[#D4AF37]">Request access</a>
        </div>
      </div>
    </div>
  );
}
